import Agent from 'infrastructure/agent';

const getDashboards = () => Agent.get('/dashboard');

const dashboardService = {
  getDashboards,
};

export default dashboardService;
